import { render } from "./Declaracoes.vue?vue&type=template&id=603e41d4&scoped=true"
import script from "./Declaracoes.vue?vue&type=script&lang=js"
export * from "./Declaracoes.vue?vue&type=script&lang=js"

import "./Declaracoes.vue?vue&type=style&index=0&id=603e41d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603e41d4"]])

export default __exports__